import { Box, Divider, Modal, rem, Stack, Text } from '@mantine/core'
import { ArrowLeftIcon } from '@phosphor-icons/react'
import type { ReactNode } from 'react'
import type { BoggleGameModeDefinition } from '~/boggle/gameModes'
import { BackButton, SecondaryButton } from '~/boggle/ui/atoms/Buttons'
import { GameModePill } from '~/boggle/ui/atoms/Labels'
import { IconGlyph } from '../atoms/Icons'

const GAME_MODE_HOW_TO_PLAY_MODAL_STYLES = {
  body: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    padding: 0,
  },
  content: {
    border: '1px solid var(--mantine-color-dark-6)',
    boxShadow: '0 12px 40px rgba(0, 0, 0, 0.55)',
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '80dvh',
    maxWidth: rem(340),
    overflow: 'hidden',
  },
  header: { display: 'none' },
} as const

export function GameModeHowToPlayModal({
  definition,
  onClose,
}: {
  definition: BoggleGameModeDefinition | null
  onClose: () => void
}) {
  const content: ReactNode = definition?.howToPlay ?? null

  return (
    <Modal
      centered
      keepMounted
      onClose={onClose}
      opened={definition !== null && content !== null}
      padding={0}
      radius="md"
      styles={GAME_MODE_HOW_TO_PLAY_MODAL_STYLES}
      title={null}
      withCloseButton={false}
    >
      <Stack align="center" gap={20} pl={30} pr={28} pt={40} pb={10}>
        {/* <Stack align="center" gap={16} w="100%">
          <Text
            span
            opacity={0.3}
            fw={800}
            lh={1}
            fz={34}
            maw={280}
            ta="center"
            ff="Tilt Neon, sans-serif"
            style={{
              textWrap: 'pretty',
              // textShadow: '1px 1px 1px black, 0 0 6px rgba(255, 255, 255, 0.6)',
            }}
          >
            How To Play
          </Text>
          <Divider w="80%" color="white" opacity={0.2} />
        </Stack> */}
        {/* {definition ? (
          <GameModePill
            color={definition.color}
            description={definition.tagline}
            name={definition.name}
            withInfoIcon={false}
            withTooltip={false}
          />
        ) : null} */}
        {/* <Text
          span
          opacity={1}
          fw={400}
          lh={1.4}
          fz={18}
          maw={280}
          ta="center"
          ff="Tilt Neon, sans-serif"
          style={{ textWrap: 'pretty' }}
        >
          {definition?.tagline}
        </Text> */}
        <Box>{content}</Box>
        <Box pb={20}>
          <SecondaryButton
            fz={14}
            onClick={onClose}
            h={46}
            leftSection={<IconGlyph icon={ArrowLeftIcon} size={16} />}
          >
            Back
          </SecondaryButton>
        </Box>
      </Stack>
    </Modal>
  )
}
